export default "__VITE_ASSET__BYUL$zbz__"